import React, { useState, useRef, useEffect } from "react";
import * as xlsx from "xlsx";
import Sidebar from "../Sidebar";
// import env from "react-dotenv";

export default function CropConditionExcelUpload() {
  const [prices2, setPrices2] = useState([]);
  const [prices, setPrices] = useState([]);
  const [rowStart, setRowStart] = useState();
  const [rowEnd, setRowEnd] = useState();

  //contains the ref
  const startRef = useRef(null);
  const endRef = useRef(null);
  const inpRef = useRef(null);

  //resetting after submit
  const reset = () => {
    setPrices2([]);
    setPrices([]);
    setRowStart();
    setRowEnd();

    startRef.current.value = "";
    endRef.current.value = "";
    inpRef.current.value = "";
  };

  useEffect(() => {
    if (rowStart && rowEnd) {
      const items = prices2.slice(rowStart - 2, rowEnd - 1);
      setPrices(items);
    } else {
      setPrices(prices2);
    }
  }, [prices2]);

  useEffect(() => {
    if (rowStart && rowEnd) {
      const items = prices2.slice(rowStart - 2, rowEnd - 1);
      setPrices(items);
    } else {
      setPrices(prices2);
    }
  }, [rowStart, rowEnd]);

  useEffect(() => {
   // console.log(prices);
  }, [prices]);

  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = event.target.result;
        try {
          const workbook = xlsx.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = xlsx.utils.sheet_to_json(worksheet);

          const selectedRows = json.map((row) => {
            const cleanedRow = {};

            // Define the fields you want to include in the output
            const fieldsToInclude = [
              "district",
              "year",
              "district_id",
              "cotton_picking",
              "avg_yield_per_acre",
              "pest_attacked",
              "avg_ball_no",
              "description",
              "year",
              "surveyType",
            ];

            // Iterate through the fields and include them if they have a value
            for (const field of fieldsToInclude) {
              if (row[field] !== undefined) {
                if (field === "date") {
                  cleanedRow[field] = xlsx.SSF.format(
                    "yyyy-mm-dd",
                    new Date((row.date - 25569) * 86400 * 1000)
                  );
                } else {
                  cleanedRow[field] = String(row[field]);
                }
              }
            }

            return cleanedRow;
            // })
          });

          setPrices2(selectedRows);
        } catch (error) {
          console.error("Error processing file:", error);
        }
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission here
    const token = sessionStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/create-multiple-agron`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(prices),
      }
    )
      
        // .then(console.log("Successfully submitted!"))
      .then(reset());
  };

  return (
    <>
      <div className="sidebar">
        <Sidebar />
      </div>
      <div style={{ paddingLeft: "300px", marginTop: "30px" }}>
        <form onSubmit={handleSubmit}>
          <h3 style={{ paddingTop: "20px", paddingBottom: "20px" }}>
            Agron File Upload
          </h3>
          <div
            style={{
              border: "1px solid black",
              padding: "10px",
              margin: "10px",
              borderRadius: "3px",
            }}
          >
            <p>
              Note:
              <ol>
                <p>
                  1. Both <strong>Start Row</strong> and{" "}
                  <strong>End Row</strong> are required to select specific rows
                  of the excel sheet.
                </p>
              </ol>
            </p>
          </div>

          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <div class="input-group mb-3" style={{ marginRight: "10px" }}>
              <span class="input-group-text" id="inputGroup-sizing-default">
                Start Row
              </span>
              <input
                type="text"
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
                onChange={(e) => setRowStart(e.target.value)}
                ref={startRef}
                required
              />
            </div>

            <div class="input-group mb-3" style={{ marginLeft: "10px" }}>
              <span class="input-group-text" id="inputGroup-sizing-default">
                End Row
              </span>
              <input
                type="text"
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
                onChange={(e) => setRowEnd(e.target.value)}
                ref={endRef}
                required
              />
            </div>
          </div>

          <div class="mb-3">
            <label for="formFile" class="form-label">
              Upload file
            </label>
            <input
              class="form-control"
              type="file"
              id="upload"
              name="upload"
              onChange={readUploadFile}
              ref={inpRef}
            />
          </div>

          <br />

          <button type="button" onClick={handleSubmit} class="btn btn-danger">
            Submit
          </button>
        </form>

        <table class="table" id="table1">
          <thead>
            <tr>
              {/* <th scope="col" id='field1'>Date</th> */}
              {/* <th scope="col">Price_id</th> */}
              <th scope="col">Crop</th>
              <th scope="col">Agron</th>
              <th scope="col">Experience</th>
              <th scope="col">LCU</th>
              <th scope="col">Crop Condition</th>
              <th scope="col">Year</th>
              <th scope="col">Survey Type</th>
            </tr>
          </thead>

          <tbody>
            {prices &&
              prices.map((price, index) => (
                <tr key={price._id}>
                  {/* <th>{price._id}</th> */}
                  <td>{price.crop}</td>
                  <td>{price.agronName}</td>
                  <td>{price.experience}</td>
                  <td>{price.LCU}</td>
                  <td>{price.cropCondition}</td>
                  <td>{price.year}</td>
                  <td>{price.surveyType}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
